import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useFrameStore } from '../seg-frame-store';
import { computeData } from '../helpers/frameLogic';
import PrintFrameSvg from './PrintFrameSvg.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintQuotePage',
    props: {
        frame: { type: null, required: true },
        index: { type: Number, required: true },
        total: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const store = useFrameStore();
        const techData = computed(() => computeData({
            dims: props.frame.dims,
            rawCosts: store.rawCosts,
            tierPrices: store.tierPrices,
            pricingTier: props.frame.pricingTier,
        }));
        const qty = computed(() => props.frame.quantity ?? 1);
        const today = new Date().toLocaleDateString('en-US', {
            year: 'numeric', month: 'long', day: 'numeric',
        });
        const tierLabel = computed(() => store.tierPrices[props.frame.pricingTier]?.label ?? props.frame.pricingTier);
        const __returned__ = { props, store, techData, qty, today, tierLabel, PrintFrameSvg };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
